package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import org.example.project.utils.All
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import kotlinx.coroutines.CoroutineScope

internal class LinkedInKpiState(val writeScope: CoroutineScope) {
    var contacts by mutableStateOf<List<All>>(emptyList())
    var deadlines by mutableStateOf<Map<String, Int>>(emptyMap())
    var selected by mutableStateOf("")
    var selectionVersion by mutableStateOf(0)
    var enabled by mutableStateOf(true)
    var loaded by mutableStateOf(false)
    private val refreshLock = Mutex()
    private var revision = 0
    private var pendingWrites = 0
    val writeQueues = mutableMapOf<String, Mutex>()
    val writeRevisions = mutableMapOf<String, Int>()

    fun beginWrite() { pendingWrites++; revision++ }
    fun finishWrite() { pendingWrites--; revision++ }
    fun replace(contact: All) {
        revision++
        contacts = contacts.map { if (it.id == contact.id) contact else it }
    }

    suspend fun refresh(initialOnly: Boolean = false) {
        // Cached readers do not wait for an already running background refresh.
        if (loaded && (initialOnly || refreshLock.isLocked)) return
        refreshLock.withLock {
            if ((initialOnly && loaded) || pendingWrites > 0) return@withLock
            val started = revision
            val data = LinkedInFlowApi.chat()
            // A response started before a local save must never undo that save.
            if (started == revision && pendingWrites == 0) update(data)
        }
    }

    fun update(data: All) {
        contacts = data.linkedinKontakte.filterNot { it.linkedinSnapshotGeloescht }
        deadlines = data.vertriebCheckpointFristen
        loaded = true
    }

    fun select(checkpoint: String) {
        selected = checkpoint
        selectionVersion++
    }
}

internal val LocalLinkedInKpis = compositionLocalOf<LinkedInKpiState?> { null }
